<div class="workflowUpload">
  <table class="base">
    @if (!projectMode) {
      <tr>
        <th>hinterlegen in:</th>
        <td>
          <select [(ngModel)]="workflowGeneratorType">
            @for (typ of workflowGeneratorTypes; track typ) {
              <option [ngValue]="typ.key">
                {{ typ.title }}
              </option>
            }
          </select>
        </td>
      </tr>
    }

    @if (projectMode && metadata) {
      <tr>
        <th>hinterlegen für Priorität:</th>
        <td>
          <select [(ngModel)]="selectedPriority">
            <option [ngValue]="0">Für alle Prioritäten (Fallback)</option>
            @for (prio of metadata.priorities; track prio) {
              <option [ngValue]="prio.id">
                {{ prio.name }}
              </option>
            }
          </select>
        </td>
      </tr>
    }
    <tr>
      <th>Dateiauswahl (aus Workflowgenerator!)</th>
      <td>
        <hawk-shared-file-input
          (saveClicked)="saveWorkflow($event)"
          acceptedFiletypes="application/json"
        ></hawk-shared-file-input>
      </td>
    </tr>

    @if (projectMode && !metadata) {
      <tr>
        <th>lade</th>
        <td></td>
      </tr>
    }
  </table>
</div>
